const getCurrentStep = (ctx) => {
  const { currentStep, journey } = ctx
  return journey?.steps?.[currentStep] || null
}

export default getCurrentStep
